import { Stack } from "@mui/material";
import { CRREM_PATHWAY_SCALE } from "features/crrem-pathway-chart/model/constants";
import type { CrremPathwayScale } from "features/crrem-pathway-chart/model/types";
import { useTranslation } from "react-i18next";

import type { CrremSettings } from "../model/types";

import { EnergyAnalysisConfigChip } from "./EnergyAnalysisConfigChip";

type CorrectionKey = "climateCorrectionEnabled" | "coverageCorrectionEnabled" | "vacancyCorrectionEnabled";

const CORRECTIONS: { iconName: "Eyeglasses" | "People" | "Sun"; key: CorrectionKey; labelKey: "climate" | "coverage" | "vacancy" }[] = [
  { iconName: "Eyeglasses", key: "coverageCorrectionEnabled", labelKey: "coverage" },
  { iconName: "Sun", key: "climateCorrectionEnabled", labelKey: "climate" },
  { iconName: "People", key: "vacancyCorrectionEnabled", labelKey: "vacancy" },
];

type EnergyAnalysisSettingsBadgesProps = {
  hideCorrections?: boolean;
  hideMetric?: boolean;
  scale: CrremPathwayScale;
  settings: CrremSettings;
};

export const EnergyAnalysisSettingsBadges = ({
  hideCorrections,
  hideMetric,
  scale,
  settings,
}: EnergyAnalysisSettingsBadgesProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="min-w-0 flex-wrap items-center gap-2">
      {hideMetric ? null : (
        <EnergyAnalysisConfigChip
          iconName="Energy"
          label={t(`BuildingProfile.energyAnalysis.settings.${settings.displayMetric}`)}
          variant="info"
        />
      )}
      <EnergyAnalysisConfigChip
        iconName="Sorting"
        label={t(`BuildingProfile.energyAnalysis.settings.${settings.trendMethod}`)}
        variant="info"
      />
      {scale === CRREM_PATHWAY_SCALE.none ? null : (
        <EnergyAnalysisConfigChip
          iconName="BuildingIcon"
          label={t(`BuildingProfile.energyAnalysis.settings.${scale}`)}
          variant="info"
        />
      )}
      {hideCorrections
        ? null
        : CORRECTIONS.map((correction) =>
            settings[correction.key] ? (
              <EnergyAnalysisConfigChip
                iconName={correction.iconName}
                key={correction.key}
                label={t(`BuildingProfile.energyAnalysis.settings.${correction.labelKey}`)}
                variant="success"
              />
            ) : null
          )}
    </Stack>
  );
};
